var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 19.5,
    fill: "#E00101"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 19.25H22.75V12.25C22.75 11.7859 22.5656 11.3408 22.2374 11.0126C21.9092 10.6844 21.4641 10.5 21 10.5C20.5359 10.5 20.0908 10.6844 19.7626 11.0126C19.4344 11.3408 19.25 11.7859 19.25 12.25V19.25H12.25C11.7859 19.25 11.3408 19.4344 11.0126 19.7626C10.6844 20.0908 10.5 20.5359 10.5 21C10.5 21.4641 10.6844 21.9092 11.0126 22.2374C11.3408 22.5656 11.7859 22.75 12.25 22.75H19.25V29.75C19.25 30.2141 19.4344 30.6593 19.7626 30.9874C20.0908 31.3156 20.5359 31.5 21 31.5C21.4641 31.5 21.9092 31.3156 22.2374 30.9874C22.5656 30.6593 22.75 30.2141 22.75 29.75V22.75H29.75C30.2141 22.75 30.6593 22.5656 30.9874 22.2374C31.3156 21.9092 31.5 21.4641 31.5 21C31.5 20.5359 31.3156 20.0908 30.9874 19.7626C30.6593 19.4344 30.2141 19.25 29.75 19.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRed);
export default __webpack_public_path__ + "static/media/add_red.7128d2e8362cbc9e6a5fa90c275553eb.svg";
export { ForwardRef as ReactComponent };